import { FC } from 'react';
import { Addon, AddonCategory, ShopContent } from '../../../types/cms_shared_types';
import { AddonListActions } from '../../../types/webshop';
import { AddonCard } from './AddonCard';

interface AddonListProps {
  addonCategory: AddonCategory;
  selectedAddons: Addon[];
  selectedAddonsActions: AddonListActions;
  cmsShopContent: ShopContent;
}

export const AddonList: FC<AddonListProps> = ({
  addonCategory,
  selectedAddons,
  selectedAddonsActions,
  cmsShopContent,
}) => {
  return (
    <div className="w-full sm:max-w-[600px] sm:w-fit flex flex-col items-center">
      {addonCategory.addons.map((addon) => (
        <AddonCard
          key={addon.code}
          addon={addon}
          addonCategory={addonCategory}
          selectedAddons={selectedAddons}
          selectedAddonsActions={selectedAddonsActions}
          cmsShopContent={cmsShopContent}
        />
      ))}
    </div>
  );
};
